export default "__VITE_ASSET__DPMr6Jv___"